// src/components/ChargingStation/EmailSection.tsx
import React from "react";
import { View, Text, TextInput, Pressable, StyleSheet } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import CreateAccountSection from "./CreateAccountSection";
import LoadingPlaceholder from "../LoadingPlaceholder";
import RoleService from "../../services/role-service";

interface EmailSectionProps {
  selectedChargerIsFree: boolean;
  activeCharges: any;
  order: any;
  sessionRole: string | string[] | undefined;
  storedEmail: string | null;
  guestEmail: string | null;
  emailValid: boolean;
  handleEmailChange: (email: string) => void;
  selectedOption: string;
  handleOptionSelect: (value: string) => void;
  handleCreateAccount: () => void;
  showCreateAccount: boolean;
  handleSignIn: () => void;
  setNewOrder?: (newOrder: any) => void;
  orderId?: string;
}

const EmailSection: React.FC<EmailSectionProps> = ({
  selectedChargerIsFree,
  activeCharges,
  order,
  sessionRole,
  storedEmail,
  guestEmail,
  emailValid,
  handleEmailChange,
  selectedOption,
  handleOptionSelect,
  handleCreateAccount,
  showCreateAccount,
  handleSignIn,
  setNewOrder,
  orderId,
}) => {
  if (selectedChargerIsFree || activeCharges || !order) {
    return null;
  }
  if (!storedEmail || RoleService.parseUserRoles(sessionRole).includes("guest")) {
    return (
      <View style={{ marginHorizontal: 16 }}>
        <Text className="py-2 text-2xl font-bold text-white">Email</Text>
        <Text className="py-2 text-xs font-medium text-zinc-400" style={styles.textColor}>
          Enter your email to receive a receipt after charging
        </Text>
        <TextInput
          placeholder="Please enter your email"
          placeholderTextColor="#808080"
          value={guestEmail ?? ""}
          onChangeText={handleEmailChange}
          style={[
            styles.BgColor6,
            emailValid ? styles.valid : styles.invalid,
          ]}
          className="px-3 py-2 m-1 text-lg rounded-full"
        />
        {!emailValid && guestEmail !== "" && (
          <Text style={styles.errorText}>Please enter a valid email address.</Text>
        )}

        <Pressable
          onPress={() => {
            handleCreateAccount();
            handleOptionSelect("checked");
          }}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }} className="mt-2 ml-2">
            <View style={styles.checkBox}>
              {selectedOption === "checked" && (
                <View style={{ width: 17, height: 17 }}>
                  <MaterialIcons name="check" size={17} color="black" />
                </View>
              )}
            </View>
            <Text className="text-xs font-medium" style={styles.textColor2}>
              Create an account to check out faster next time
            </Text>
          </View>
        </Pressable>

        <Pressable onPress={handleSignIn}>
          <View className="flex flex-row gap-2 justify-center items-center mt-2 mb-4">
            <Text className="text-xs font-medium text-white">{`Already have an account?`}</Text>
            <Text className="text-xs font-medium" style={styles.textColorTeal}>{` Log in`}</Text>
            <MaterialIcons name="keyboard-arrow-right" size={16} color="white" />
          </View>
        </Pressable>

        {showCreateAccount && (
          <CreateAccountSection 
            formEmail={guestEmail || ""} 
            handleCreateAccount={handleCreateAccount}
            setNewOrder={setNewOrder}
            orderId={orderId}
          />
        )}
      </View>
    );
  }
  return null;
};

const styles = StyleSheet.create({
  BgColor6: {
    backgroundColor: "#E8E8E9",
  },
  valid: {
    borderColor: "green",
  },
  invalid: {
    borderColor: "red",
  },
  textColor: {
    color: "#D1D2D3",
  },
  textColor2: {
    color: "#A3A5A6",
  },
  textColorTeal: {
    color: "#39BEB7",
  },
  errorText: {
    color: "red",
    fontSize: 12,
    marginTop: 4,
  },
  checkBox: {
    width: 19,
    height: 19,
    borderWidth: 2,
    marginRight: 8,
    borderColor: "#E8E8E9",
    backgroundColor: "#E8E8E9",
    borderRadius: 4,
  },
});

export default EmailSection;
